const ActionSummaryType = {
    EXPORT: 1,
    UPLOAD_REPORT: 2
}
export default ActionSummaryType